import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../State';
import { EventResolver } from './event.resolver';
import {
    getEventFetched,
    getEventLatestFilteredUpdatedAt,
    getEventLatestUpdatedAt,
} from '../State/selectors/events.selectors';
import { filter, map, startWith, switchMap, take, tap } from 'rxjs/operators';
import { EventsActionTypes } from '../State/actions/events.actions';
import { combineLatest, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DashboardEventResolver {
    constructor(
        private store: Store<State>,
        private eventResolver: EventResolver
    ) {}

    resolve(userId: number): Observable<boolean> {


        return combineLatest([
            this.store.select(getEventLatestUpdatedAt),
            this.store.select(getEventLatestFilteredUpdatedAt)
        ]).pipe(
            take(1),
            switchMap(([allEventsFetched, filteredEventsUpdatedAt]) => {
                if (allEventsFetched) {
                    return this.eventResolver.resolve();
                } else{
                    const filterString = JSON.stringify({
                        AdditionalDataIsNotLike: "IsDailyToDo\":true",
                        IsTask: true,
                        StateIsNot: "done",
                        User2EventUserId: userId
                    });
                    if (filteredEventsUpdatedAt) {
                    this.store.dispatch(EventsActionTypes.Load({
                        Payload: {
                            filter: filterString,
                            updatedSince: new Date(filteredEventsUpdatedAt).toISOString()
                        }
                    }));
                    return of(true);
                } else {
                    this.store.dispatch(EventsActionTypes.Load({
                        Payload: {
                            filter: filterString
                        }
                    }));
                    return of(true);
                }
            }
            })
        );
    }

}
